// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","246":"component---src-pages-landing-page-landing-page-tsx","562":"component---src-pages-on-construction-tsx"}[chunkId] + "-" + {"245":"deffb7f764c18e2a0714","246":"ab2a5276b70e0c35d700","562":"352c7c83e490429aab6c"}[chunkId] + ".js";
};